import { ForgotPassword, ResetPassword, Signup } from "./pages";
import ResetPasswordSuccess from "./pages/Password-Reset-Success/resetPasswordSuccess";
import Login from "./pages/login/login";
import Profile from "./pages/Profile";
import FoodMenu from "./pages/Food-Menu";
import SubscriptionPlans from "./pages/Plans";
import { Feedback } from "./pages/feedback";
import { DashboardPage } from "./pages/Dashboard";
import { MealCalendar } from "./pages/Meal-Calendar";
import { HelpPage } from "./pages/Help";
import { MyPlan } from "./pages/My-Plans";
import AddMeal from "./pages/Admin/Add-Meal";
import MealLibrary from "./pages/Admin/Meal-Library";
import MealCategories from "./pages/Admin/Meal-Categories";
import TastePreferences from "./pages/Admin/Taste-Preferences";
import Professions from "./pages/Admin/Professions";
import Notes from "./pages/Admin/Notes";
import Notifications from "./pages/Admin/Notifications";
import CancelRequest from "./pages/Cancel-Request";
import { UserListWithCancelRequest } from "./pages/Admin/User-List-of-Cancel-Request";
import { UserListOfMealDelivery } from "./pages/Admin/User-List-Of-Meal-Delivery";
import { CustomizeYourMeal } from "./pages/customize-your-meal";
import { AllRegisteredUsers } from "./pages/Admin/All-Registered-Users";
import { UserListWithCustomisationRequest } from "./pages/Admin/User-List-of-Customisation-Request";
import { MealTracking } from "./pages/MealTracking";
import AddHoliday from "./pages/Add-Holiday";
import AllHolidays from "./pages/All-Holidays";
import { UserMealTracking } from "./pages/Admin/User-Meal-Tracking";
import { DietaryStockReport } from "./pages/Admin/Dietary-Stock-Report";
import { Expenses } from "./pages/Admin/Expenses";
import { ManageSubscriptions } from "./pages/Admin/Manage-Subscriptions";
import { FinanceDashboard } from "./pages/Admin/Finance-Dashboard";
import { AuditLog } from "./pages/Admin/Audit-Log";
export const routes = [
  {
    path: "/",
    component: Login,
    exact: true,
  },
  {
    path: "/signup",
    component: Signup,
    exact: true,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    exact: true,
  },
  {
    path: "/reset-password-successfully",
    component: ResetPasswordSuccess,
    exact: true,
  },
  {
    path: "/reset-password/:token",
    component: ResetPassword,
    exact: true,
  },
  {
    path: "/dashboard/profile",
    component: Profile,
    exact: true,
  },
  {
    path: "/dashboard/food-menu",
    component: FoodMenu,
    exact: true,
  },
  {
    path: "/dashboard/plans",
    component: SubscriptionPlans,
    exact: true,
  },
  {
    path: "/dashboard/feedback",
    component: Feedback,
    exact: true,
  },
  {
    path: "/dashboard",
    component: DashboardPage,
    exact: true,
  },
  {
    path: "/dashboard/meal-calendar",
    component: MealCalendar,
    exact: true,
  },
  {
    path: "/dashboard/help",
    component: HelpPage,
    exact: true,
  },
  {
    path: "/dashboard/my-billing",
    component: MyPlan,
    exact: true,
  },
  {
    path: "/dashboard/add-menu",
    component: AddMeal,
    exact: true,
  },
  {
    path: "/dashboard/meal-library",
    component: MealLibrary,
    exact: true,
  },
  {
    path: "/dashboard/meal-categories",
    component: MealCategories,
    exact: true,
  },
  {
    path: "/dashboard/taste-preferences",
    component: TastePreferences,
    exact: true,
  },
  {
    path: "/dashboard/professions",
    component: Professions,
    exact: true,
  },
  {
    path: "/dashboard/notes",
    component: Notes,
    exact: true,
  },
  {
    path: "/dashboard/notifications",
    component: Notifications,
    exact: true,
  },
  {
    path: "/dashboard/cancel-request",
    component: CancelRequest,
    exact: true,
  },
  {
    path: "/dashboard/user-cancel-request-list",
    component: UserListWithCancelRequest,
    exact: true,
  },
  {
    path: "/dashboard/meal-delivery-list",
    component: UserListOfMealDelivery,
    exact: true,
  },
  {
    path: "/dashboard/customize-your-meal",
    component: CustomizeYourMeal,
    exact: true,
  },
  {
    path: "/dashboard/all-registered-users",
    component: AllRegisteredUsers,
    exact: true,
  },
  {
    path: "/dashboard/get-list-of-customisation-request",
    component: UserListWithCustomisationRequest,
    exact: true,
  },
  {
    path: "/dashboard/meal-tracking",
    component: MealTracking,
    exact: true,
  },
  {
    path: "/dashboard/add-holiday",
    component: AddHoliday,
    exact: true,
  },
  {
    path: "/dashboard/all-holiday",
    component: AllHolidays,
    exact: true,
  },
  {
    path: "/dashboard/user-meal-tracking",
    component: UserMealTracking,
    exact: true,
  },
  {
    path: "/dashboard/dietary-stock-report",
    component: DietaryStockReport,
    exact: true,
  },
  {
    path: "/dashboard/expenses",
    component: Expenses,
    exact: true,
  },
  {
    path: "/dashboard/manage-subscriptions",
    component: ManageSubscriptions,
    exact: true,
  },
  {
    path: "/dashboard/finance-dashboard",
    component: FinanceDashboard,
    exact: true,
  },
  {
    path: "/dashboard/audit-log",
    component: AuditLog,
    exact: true,
  }
];
